export default {"src":"/_next/static/media/vissen.5f9a927b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};